import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { Return } from 'src/models/requestModels/returns/return';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { OrderReturnServiceService } from 'src/services/request/returns/order-return-service.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { ReturnService } from 'src/services/state/return/return.service';

@Component({
  selector: 'app-return-reason',
  templateUrl: './return-reason.component.html',
  styleUrls: ['./return-reason.component.css']
})
export class ReturnReasonComponent extends HistoryBaseComponent implements OnInit {

  private _oderUUID = '';
  private _cartLineUUID = '';
  private _reasons = {
    unpacked: "WANT_TO_RETURN_UNOPENED_PRODUCT",
    description: "PRODUCT_DIDNT_FIT_DESCRIPTION",
    nonworking: "PRODUCT_NOT_WORKING",
    delivery: "DELIVERY_TOOK_MORE_THAN_DESCRIBED",
    mistake: "ORDERED_BY_MISTAKE_OR_NOT_NEEDED_ANYMORE"
  };
  private _reason = '';
  private _returnInfo?: Return;



  constructor(
    private returnState: ReturnService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected location: Location,
    protected historyService: HistoryService,
  ) { 
    super(location, historyService);
    this.returnState.returnInfo$.subscribe(returnInfo => {
      this._returnInfo = returnInfo
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._oderUUID = params.orderUUID;
      this._cartLineUUID = params.cartLineUUID;
    })
  }

  get reason() {
    return this._reason;
  }

  set reason(value: string) {
    this._reason = value;
  }

  get reasons() {
    return this._reasons;
  }

  continue() {
    this._returnInfo!.reason = this._reason;
    this.returnState.addNewOrderInfo(this._returnInfo!)
    this.router.navigate(['return/user/data/' + this._oderUUID + '/' + this._cartLineUUID])
  }

  toggleCheckbox(e: any, reason: string) {
    if (this.reason == reason) {
      this.reason = '';
      e.preventDefault();
      return;
    }
    this.reason = reason;
  }
}
